import { useRecoilState, atom} from "recoil";

import appConfig from "../config/app.config";
import { API_STATUS } from "../constants/app.constants";
import useRestApiCall from "../http.interceptor";


const { LOADING, SUCCESS, ERROR } = API_STATUS;

const CLIENT_CREDENTIALS_INTIAL_STATE = {
    status: LOADING,
    content: null
};

export const clientCredentialsAtom = atom({
    key: "clientCredentialsState",
    default: CLIENT_CREDENTIALS_INTIAL_STATE,
});


const getClientCredntialsPayload = () => {
    let apiPayload = {
        method: "GET",
        url: "/api/iot/mapper/get/api/credentials",
        baseURL: appConfig.apiMarketplaceBaseUrl,
    };
    return apiPayload;
}


const useGetClientCredentials = () => {

    const [clientCredentials, setClientCredentials] = useRecoilState(clientCredentialsAtom);
    const { apiCall } = useRestApiCall();
    const { status, content } = clientCredentials;
   

    const getClientCredentials = async () => {
        const payload = getClientCredntialsPayload();
        try {
            const response = await apiCall(payload);
            if (response?.data) {
                setClientCredentials({ status: SUCCESS, content: response.data });
                return response.data;
            }
            throw new Error(response.data);

        }
        catch (error) {
            setClientCredentials({ status: ERROR, content: error })
        }
    }

    const clearClientCredntials = () => {
        setClientCredentials(CLIENT_CREDENTIALS_INTIAL_STATE);
    }



    return { status, content, getClientCredentials, clearClientCredntials };

}

export default useGetClientCredentials;